import styled from 'styled-components';

const References = styled.div`
  font-size: ${props => props.theme.fontSizes.small};
  font-style: italic;
`;

export default References;
